// SalesSummaryChart.jsx
import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

// Register necessary chart.js modules
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const SalesSummaryChart = ({ dataset }) => {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false, // Only one dataset: hide legend
      },
      title: {
        display: true,
        text: "Revenue by Store",
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.raw;
            return `${value.toLocaleString()}`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            return `${value.toLocaleString()}`;
          },
        },
        title: {
          display: true,
          text: "Revenue",
        },
      },
      x: {
        title: {
          display: true,
          text: "Store",
        },
      },
    },
  };

  return (
    <div className=" p-4 rounded shadow mt-6">
      <Bar data={dataset} options={options} />
    </div>
  );
};

export default SalesSummaryChart;
